import templateReplace from 'es6-template-strings';
import { useCallback, useState } from 'react';

import { get, isEmpty } from 'ravenjs/utils/lodash';
import { CLICK_TO_BUY } from 'constants/clickToBuy';

export function useC2BPricing({ fetchPaymentPageRedirectUrl, fetchPricing, loggedUser }) {
    const [error, setError] = useState('');

    const getPaymentRedirectUrl = useCallback(
        async ({ isFeatureFlagEnabled = false, quoteId }) => {
            let paymentRedirectUrl = '';
            if (!isEmpty(quoteId)) {
                try {
                    const response = await fetchPaymentPageRedirectUrl({
                        isFeatureFlagEnabled,
                        quoteId,
                    });
                    const redirectUrl = get(response, 'payment_detail.url', '');
                    paymentRedirectUrl = redirectUrl;
                } catch (err) {
                    paymentRedirectUrl = '';
                    setError(err);
                }
            }

            return paymentRedirectUrl;
        },
        [fetchPaymentPageRedirectUrl]
    );

    const getQuotation = useCallback(
        async ({
            totalEmpCount,
            productCode,
            productSalesforceId,
            isFeatureFlagEnabled = false,
        }) => {
            let quotation = {
                id: '',
                price: CLICK_TO_BUY.COMMON.PRICING_CONFIRMATION.UNKNOWN_PRICING,
            };

            try {
                const { company, info } = loggedUser;
                const {
                    partnerId,
                    companyId,
                    companyName,
                    salesforceId: companySalesforceId,
                } = company;
                const companySize = get(company, 'companySize', 0);
                const { userId, email, salesforceId: userSalesforceId } = info;

                const payload = {
                    contact: {
                        id: userId,
                        email,
                        sfdcId: userSalesforceId,
                    },
                    company: {
                        name: companyName,
                        id: companyId,
                        partnerId,
                        sfdcId: companySalesforceId,
                        employeeCount: totalEmpCount || companySize,
                    },
                    product: {
                        code: productCode,
                        sfdcId: productSalesforceId,
                        termInMonths: CLICK_TO_BUY.SEHP.SMART_HANDBOOK.TERMS_IN_MONTHS,
                    },
                };
                const pricingResponse = await fetchPricing({ payload, isFeatureFlagEnabled });
                const pricingData = get(pricingResponse, 'quote', {});
                const priceLabel = templateReplace(
                    CLICK_TO_BUY.COMMON.PRICING_CONFIRMATION.INSTRUCTION_1,
                    {
                        pricing: get(pricingData, 'pricing', '0'),
                        termInMonths: get(pricingData, 'termInMonths', '0'),
                    }
                );
                const salesforceC2bId = get(pricingData, 'salesforceC2bId', '');
                quotation = {
                    id: salesforceC2bId,
                    price: priceLabel,
                };
            } catch (err) {
                setError(err);
            }

            return quotation;
        },
        [fetchPricing, loggedUser]
    );

    return { error, getPaymentRedirectUrl, getQuotation };
}
